import { DefaultOptionType } from 'antd/lib/select'
import { toLabeledValues as to } from 'components/CIMSSelect/utils/labeledValues'
import { FromLabeledValuesValue, IssueReportOption } from './types'
import { IssueReportType } from '@cims-online/shared'
import { SEPARATOR } from 'components/CIMSSelect/common/types'

export function toLabeledValues(
  items: (IssueReportOption | null | undefined)[] | undefined | null
) {
  return to(
    items?.reduce((options, option) => {
      if (option) options.push(option)
      return options
    }, Array<IssueReportOption>()),
    {
      type: 'callback',
      callback: (item) => {
        let label, tooltip
        if (item.__typename === 'AsphaltLot') {
          label = item.asphaltLotId
          tooltip = IssueReportType.AsphaltLot.type
        } else if (item.__typename === 'ConcreteTest') {
          label = item.fieldNumber
          tooltip = IssueReportType.ConcreteTest.type
        } else if (item.__typename === 'ConcreteTestSet') {
          label = item.testSetId
          tooltip = IssueReportType.ConcreteTestSet.type
        } else if (item.__typename === 'DailyInspectionControlPoint') {
          label = item.controlPointId
          tooltip = IssueReportType.DailyInspectionControlPoint.type
        } else if (item.__typename === 'DailyInspectionInspection') {
          label = item.inspectionId
          tooltip = IssueReportType.DailyInspectionInspection.type
        } else if (item.__typename === 'DailyInspectionPunchList') {
          label = item.punchListId
          tooltip = IssueReportType.DailyInspectionPunchList.type
        } else if (item.__typename === 'Lot') {
          label = item.lotId
          tooltip = IssueReportType.DensityLot.type
        }
        return {
          label: label ?? item.globalId,
          value: join(item),
          tooltip,
        }
      },
    }
  )
}

export function split(
  value: DefaultOptionType['value']
): FromLabeledValuesValue {
  const [typename, itemId] =
    (value?.toString().split(SEPARATOR) as [
      IssueReportOption['__typename'],
      string
    ]) ?? []
  const { id } = IssueReportType.findOrFail(
    ({ classType }) => typename === classType
  )
  return { reportId: itemId, reportTypeId: id }
}

export const join = (item: IssueReportOption) =>
  `${item.__typename}${SEPARATOR}${item.globalId}`
